import _ from 'lodash'

export class ChosenTickets {
    constructor(tickets) {
        this.tickets = tickets;
    }

    addImmutably(ticket) {
        const ticketIndex = _.findIndex(this.tickets, { name: ticket.name });
        if (ticketIndex === -1) {
            return new ChosenTickets([...this.tickets, ticket]);
        }

        const newTickets = _.clone(this.tickets);
        newTickets[ticketIndex] = ticket;
        return new ChosenTickets(newTickets);
    }

    getByName(name) {
        return _.find(this.tickets, {name: name});
    }

    getCount() {
        return _.sumBy(this.tickets, 'count');
    }

    getCost() {
        return _.sumBy(this.tickets, t => t.price * t.count);
    }

    getOrderSequence() {
        return this.tickets.filter(ticket => ticket.count > 0).map(ticket => {
            return {
                key: ticket.key,
                type: ticket.type,
                count: ticket.count,
                book_randomly: ticket.bookRandomly
            };
        });
    }
}
